import { apiRequest } from '../services/apiRequest'

export const Invites = {
  sendInvite: async (data) => await apiRequest('post', '/api/invites/', data),
  getInvites: async (data) =>
    await apiRequest('get', `/api/invites/business_id=${data}`),
  getUserList: async (data) => {
    // Create an object with provided params
    const params = new URLSearchParams()

    if (data.status) params.append('status', data.status)
    if (data.name) params.append('name', data.name)
    if (data.role) params.append('role', data.role.toUpperCase())
    if (data?.business) params.append('business_id', data.business)
    if (data?.page) params.append('page', data.page)

    // Construct the full URL dynamically
    const url = `/account/users/list${
      params.toString() ? `?${params.toString()}` : ''
    }`

    return await apiRequest('get', url)
  },
  exportUserListCsv: async (data = {}) => {
    const params = new URLSearchParams()

    params.append("export", "csv")
    if (data.status) params.append("status", data.status)
    if (data.name) params.append("name", data.name)
    if (data.role) params.append("role", data.role.toUpperCase())
    if (data?.business) params.append("business_id", data.business)

    const url = `/account/users/list/?${params.toString()}`
    return await apiRequest("get", url, undefined, { responseType: "blob" })
  },
  updateInvitedUserStatus: async (data, userId) =>
    await apiRequest(`patch`, `/account/users/status/${userId}`, data),
  updateInvitedUserRole: async (data, userId) =>
    await apiRequest(`patch`, `/account/users/update/${userId}`, data),
  deleteInvitedUser: async (userId) =>
    await apiRequest(`delete`, `/account/users/delete/${userId}`),
}
